module.exports = __webpack_public_path__ + "img/speaker_18.4cabf952.jpg";